import { useFetch } from "./useFetch"

export const sectionAPI = async (base, section, params = '?section_id=') => {
  return await useFetch(base+params+section);
}

export const sectionAll = async (section) => {

  return await useFetch(`?section_id=${section}`);
}
